$(document).ready(function () {
    //Check for browser support.
    if ('loading' in HTMLImageElement.prototype) {
        const images = document.querySelectorAll('img[loading="lazy"]')
        //copy the value of the data-src to the src.
        images.forEach(img => img.src = img.dataset.src)
    } else {
        //if no support, async load the lazysizes plugin
        let script = document.createElement("script");
        script.async = true;
        script.src =
            "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.1.8/lazysizes.min.js";
        document.body.appendChild(script);
    }


    const hamburger = document.querySelector('.hamburger'),
        menu = document.querySelector('.header__menu__wrapper'),
        list = document.querySelector('.header__list');

    hamburger.addEventListener('click', function () {
        hamburger.classList.toggle('active1');
        menu.classList.toggle('active1');
    });
    menu.addEventListener('click', function () {
        hamburger.classList.toggle('active1');
        menu.classList.toggle('active1');
    });

    //slider 1 

    $(document).ready(function () {
        $('.bien__carousel').on('init', function (event, slick) {
            $('.bien__carousel').append('<div class="slider-count bien__number"><p><span id="current">1</span>/<span id="total">' + slick.slideCount + '</span></p></div>');
        });
        $('.bien__carousel').slick(
            {
                infinite: true,
                speed: 700,
                autoplay: true,
                fade: true,
                autoplaySpeed: 7000,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            }
        );
        $('.bien__carousel')
            .on('afterChange', function (event, slick, currentSlide) {
                // finally let do this after changing slides
                $('.slider-count #current').html(currentSlide + 1);
            });
    });

    //slider 2
    $(document).ready(function () {
        // $('.iniciativas__carousel').on('init', function(event, slick){
        //     $('.iniciativas__slides[data-slick-index="0"]').prev().addClass('first-slide');
        // });
        $('.iniciativas__carousel').slick(
            {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                speed: 700,
                autoplay: true,
                autoplaySpeed: 7000,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            dots: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: 1,
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            }
        );
    });

    //slider 3
    $(document).ready(function () {
        if ($('.projectos__carousel')) {
            $('.projectos__carousel').slick(
                {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    speed: 700,
                    autoplay: true,
                    autoplaySpeed: 7000,
                    prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/left.svg"></button>',
                    nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/right.svg"></button>',
                    arrows: false,
                    responsive: [
                        {
                            breakpoint: 993,
                            settings: {
                                dots: true,
                                arrows: false
                            }
                        }
                    ]
                }
            );
        }
    });


    $(document).ready(function () {
        $('.baby__carousel').on('init', function (event, slick) {
            $('.baby__carousel').append('<div class="slider-count bien__number"><p><span id="current">1</span>/<span id="total">' + slick.slideCount + '</span></p></div>');
        });
        $('.baby__carousel').slick(
            {
                infinite: true,
                speed: 700,
                autoplay: true,
                fade: true,
                autoplaySpeed: 7000,
                prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/left.svg"></button>',
                nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/right.svg"></button>',
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            }
        );
        $('.baby__carousel')
            .on('afterChange', function (event, slick, currentSlide) {
                // finally let do this after changing slides
                $('.slider-count #current').html(currentSlide + 1);
            });
    });

    //slider 5
    $(document).ready(function () {
        if ($('.social__wrapper')) {
            $('.social__wrapper').slick(
                {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    speed: 700,
                    // autoplay: true,
                    autoplaySpeed: 7000,
                    arrows: false,
                    responsive: [
                        {
                            breakpoint: 993,
                            settings: {
                                dots: true,
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                dots: true,
                            }
                        }
                    ]
                }
            );
        }
    });

    //slider 6
    $(document).ready(function () {
        $('.form__carousel').on('init', function (event, slick) {
            $('.form__carousel').append('<div class="slider-count form__number"><p><span id="current1">1</span>/<span id="total">' + slick.slideCount + '</span></p></div>');
        });
        $('.form__carousel').slick(
            {
                // infinite: true,
                slidesToShow: 1,
                centerMode: true,
                // centerPadding: "80px",
                slidesToScroll: 1,
                speed: 700,
                // autoplay: true,
                autoplaySpeed: 7000,
                prevArrow: '<button type="button" class="slick-prev"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/left.svg"></button>',
                nextArrow: '<button type="button" class="slick-next"><img src="/wp-content/themes/split_juegaterapia/assets/img/icons/right.svg"></button>',
                responsive: [
                    {
                        breakpoint: 993,
                        settings: {
                            dots: true,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            centerMode: false,
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            }
        );
        $('.form__carousel')
            .on('afterChange', function (event, slick, currentSlide) {
                // finally let do this after changing slides
                $('.slider-count #current1').html(currentSlide + 1);
            });
    });

    //footer accordion
    $(document).ready(function () {
        var acc = document.getElementsByClassName("footer__accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                /* Toggle between adding and removing the "active" class,
                to highlight the button that controls the panel */
                //this.classList.toggle("active");

                /* Toggle between hiding and showing the active panel */
                var panel = this.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    });
});

